import type { CSSProperties, ReactNode } from 'react';
import { cx } from '../utils.ts';
import './display.css';

export function Spinner({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <svg className={cx('g-spinner', className)} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
      <path d="M21 12a9 9 0 0 0-9-9" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function Skeleton({ width, height = 14, radius, className, style }: { width?: number | string; height?: number | string; radius?: number; className?: string; style?: CSSProperties }) {
  return <span className={cx('g-skeleton', className)} style={{ width, height, borderRadius: radius, ...style }} aria-hidden="true" />;
}

export interface EmptyStateProps {
  /** Illustration or icon. */
  art?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function EmptyState({ art, title, description, actions, size = 'md', className }: EmptyStateProps) {
  return (
    <div className={cx('g-empty', className)} data-size={size}>
      {art && <div className="g-empty__art">{art}</div>}
      <h3 className="g-empty__title">{title}</h3>
      {description && <p className="g-empty__desc">{description}</p>}
      {actions && <div className="g-empty__actions">{actions}</div>}
    </div>
  );
}
